import { useEffect, useState } from "react";
import VideoRecorder from "./component/VideoComponent";
import FaceDetector from "./component/FaceDetector";
import { v4 as uuidv4 } from 'uuid';
import { Documentation } from "./component/Documentation";
import { DocumentUpload } from "./component/DocumentUpload";
import VideoRecordingComponent from "./component/VideoRecorderCompo";
import { Provider } from "react-redux";
import { store } from "./store/store"; // Adjust the import path as necessary
import CryptoService from './component/CyrptoService';

const styles = {
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    width: "400px",
    textAlign: "center",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
  },
  title: {
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  subtitle: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "red",
  },
  instructions: {
    fontSize: "14px",
    marginBottom: "10px",
  },
  list: {
    textAlign: "left",
    paddingLeft: "20px",
    fontSize: "14px",
    marginBottom: "20px",
  },
  retryButton: {
    backgroundColor: "#1E3A8A",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
  },
  note: {
    marginTop: "10px",
    fontSize: "12px",
    color: "gray",
  },
};


function App() {
  const [faceNotmatchStartAgain, setFaceNotmatchStartAgain] = useState(false)
  const [success, setSuccess] = useState(false);
  const [optStatus, setOptstatus] = useState(false);
  const [videoStatus, setVideoStatus] = useState(false);
  const [popMessage, setPopMessage] = useState(false);
  const [popMessageText, setPopMessageText] = useState('');
  const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
  const [flowDoc, setFlowDoc] = useState('');
  const [documentImage, setDocumentImage] = useState('');
  const [documentUplaod, setDocumentUpload] = useState(true);
  const [validDocument, setvalidDocument] = useState(false);
  const [refId, setERefID] = useState('')

  // const obj = "dxXU"
  useEffect(() => {
    if (optStatus) {
      setTimeout(() => {
        setVideoStatus(true)
      }, 2000)
    }

    // Encrypt
    // const encrypted = CryptoService.encrypt(obj);
    // console.log('Encrypted:', encrypted);

    // Decrypt
    // const decrypted = CryptoService.decrypt(obj);
    // console.log('Decrypted:', JSON.parse(decrypted));

  }, [optStatus]);

  // useEffect(() => {
  //   // Check for location permission
  //   if (!isIOS) {
  //     navigator.permissions.query({ name: 'geolocation' }).then((result) => {
  //       if (result.state !== 'granted') {
  //         setPopMessage(true);
  //         setPopMessageText('Location permission is required.');
  //       }
  //     });

  //     // Check for camera permission
  //     navigator.permissions.query({ name: 'camera' }).then((result) => {
  //       if (result.state !== 'granted') {
  //         setPopMessage(true);
  //         setPopMessageText('Camera permission is required.');
  //       }
  //     });

  //     // Check for microphone permission
  //     navigator.permissions.query({ name: 'microphone' }).then((result) => {
  //       if (result.state !== 'granted') {
  //         setPopMessage(true);
  //         setPopMessageText('Microphone permission is required.');
  //       }
  //     });
  //   }
  // }, []);

  const handleDocumentUplaod = () => {
    setDocumentUpload(false)
  }

  if (popMessage) {
    return <>
      <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', height: '100vh' }}>
        <div style={styles.modal}>
          <div style={styles.container}>
            <h2 style={styles.title}>Allow Permissions</h2>
            <p style={styles.subtitle}>{popMessageText}</p>
            <p style={styles.instructions}>Steps to continue to use</p>
            <ol style={styles.list}>
              <li>Click The Lock Icon On Top-Left Of The Screen.</li>
              <li>Click "Site Settings"</li>
              <li>Click "Clear & Reset"</li>
              <li>Click On "Retry Button"</li>
            </ol>
            <button style={styles.retryButton} onClick={() => window.location.reload()}>RETRY</button>
            <p style={styles.note}>
              <strong>Note:</strong> If you didn’t deny location permission, kindly copy the link and open in Chrome Browser.
            </p>
          </div>
        </div>
      </div>
    </>
  }

  if (success) {

    return <>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        gap: '8px',
        padding: '8px',
        backgroundColor: '#d4edda',
        color: '#155724',
        borderRadius: '5px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        width: 'fit-content'
      }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
        <span style={{ fontSize: '14px', fontWeight: '500' }}>OVD Successfully Completed</span>
      </div>
    </>
  }

  const componentsMap = {
    DocumentUpload: (
      <DocumentUpload
        setFlowDoc={setFlowDoc}
        setDocumentImage={setDocumentImage}
        setvalidDocument={setvalidDocument}
        setERefID={setERefID}
        refId={refId}
      />
    ),
    VedioRecorder: (
      <VideoRecordingComponent
        setFlowDoc={setFlowDoc}
        setSuccess={setSuccess}
        documentImage={documentImage}
        setFaceNotmatchStartAgain={setFaceNotmatchStartAgain}
        refId={refId}
      />
    ),
    default: (
      <Documentation
        setFlowDoc={setFlowDoc}
        handleDocumentUplaod={handleDocumentUplaod}
        setDocumentImage={setDocumentImage}
        faceNotmatchStartAgain={faceNotmatchStartAgain}
        setERefID={setERefID}
         setSuccess={setSuccess}
      />
    ),
  };

  return <>
    <Provider store={store}>
      <div style={{ position: 'relative' }}>
        {componentsMap[flowDoc] || componentsMap.default}

        {/* <Documentation
        setFlowDoc={setFlowDoc}
        handleDocumentUplaod={handleDocumentUplaod}
        faceNotmatchStartAgain={faceNotmatchStartAgain}
      />
      <DocumentUpload
        setFlowDoc={setFlowDoc}
        setDocumentImage={setDocumentImage}
        setvalidDocument={setvalidDocument}
      /> */}
        {/* <VideoRecordingComponent
        setFlowDoc={setFlowDoc}
        setSuccess={setSuccess}
        documentImage={documentImage}
        setFaceNotmatchStartAgain={setFaceNotmatchStartAgain}
      /> */}
      </div>
    </Provider>
  </>

}

export default App;